import { AngularFireAuth } from '@angular/fire/compat/auth';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { first } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GovernmentAccountSubtype } from 'src/app/entities/worklist';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { Location } from '@angular/common'
import { ArtemisCitizensCharterViewComponent } from '../../artemis-citizens-charter-view/artemis-citizens-charter-view.component';

@Component({
  selector: 'app-charter-reports',
  templateUrl: './charter-reports.component.html',
  styleUrls: ['./charter-reports.component.scss']
})
export class CharterReportsComponent implements OnInit {
  @ViewChild(ArtemisCitizensCharterViewComponent) aCCViewComponent: ArtemisCitizensCharterViewComponent

  //number formatting
  ordinals: string[] = ['th', 'st', 'nd', 'rd'];

  // cc_id:any = this.route.snapshot.params.id
  // agency_id:any = this.route.snapshot.queryParams.agency
  cc_id: any;
  agency_id: any;
  currentCC: any;
  currentCCReportURL: any;
  agencies: any[] = []
  agencyName: any;
  currentAgency: any;
  headOfAgency: any[] = [];
  chairPerson: any[] = [];
  viceChairPerson: any[] = [];
  member: any[] = [];
  // services:any[] = []
  services: any = {
    internal: [],
    external: []
  }

  disabler: boolean = true;
  ng_if: boolean = false;

  loader: boolean = true;
  loaderGenerateDoc: boolean = false;
  loaderCheckFile: boolean = false;

  currentUser: any;

  isAgencyHead: boolean = false;
  isArta: boolean = false;
  isEncoder: boolean = false;
  isVerifier: boolean = false;
  isSubmissionOnly: boolean = false

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private afs: AngularFirestore,
    private http: HttpClient,
    public auth: AngularFireAuth,
    private store: AngularFireStorage,
    private _location: Location,
  ) {
    //console.log('CharterReportsComponent 1')
    this.checkUser();
  }

  ngOnInit(): void {
    // console.log('CharterReportsComponent 2')
    this.loader = true;
    this.route.queryParams.subscribe({
      next: (result) => {
        //console.log('Edition: ',result.edition)
        this.isSubmissionOnly = result?.submittedonly
        if (result.cc_id) {
          this.cc_id = result.cc_id
        }
        else if (result.agency) {
          this.agency_id = result.agency
        }
      },
      error: (err) => {
        console.error('Error: ', err)
      }
    })
  }

  updateCCLogo() {
    this.afs.collection('citizens-charter-phase-02').doc(this.cc_id)
      .snapshotChanges()
      .pipe(first())
      .subscribe()
  }

  checkUser() {
    //console.log('checkUser')
    if (sessionStorage.getItem('user_type')) {
      const userType = sessionStorage.getItem('user_type')
      //console.log('userType: ',userType)
      switch (userType) {
        case 'agency': {
          //console.log('account_subtype: ',sessionStorage.getItem('account_subtype'))
          if (sessionStorage.getItem('account_subtype')) {
            const accountSubtype = sessionStorage.getItem('account_subtype')
            switch (accountSubtype) {
              case GovernmentAccountSubtype.AGENCY_DIR: {
                this.isAgencyHead = true
                break
              }
              case GovernmentAccountSubtype.AGENCY_VER: {
                this.isVerifier = true
                break
              }
              case GovernmentAccountSubtype.AGENCY_ENC: {
                this.isEncoder = true
                break
              }
            }
          }
          break;
        }
        case 'arta': {
          this.isArta = true
          break;
        }
        default: {
          // this.router.navigate(['/artemis/citizen-charter/view/',this.cc_id])
          // this.router.navigate(['/artemis/citizen-charter/view/'],{
          //   queryParams:{cc_id: this.cc_id}
          // })
          //this.goToCC()
          break;
        }
      }
    } else {
      // this.router.navigate(['/artemis/citizen-charter/view/',this.cc_id])
      //this.goToCC()
    }
  }

  transform(n: number, year: string, keepNumber: boolean = true) {
    if (n != null) {
      let v = n % 100;
      return year + " " + (keepNumber ? n : '') + (this.ordinals[(v - 20) % 10] || this.ordinals[v] || this.ordinals[0]) + " Edition";
    }
    return 'Edition'
  }

  //file generation
  generateReport() {
    // console.log('generateReport')
    this.loader = true
    this.loaderGenerateDoc = true
    if (this.currentCC && this.currentAgency) {
      this.generatePDFFile(this.currentCC)
    }
    else {
      // console.log("can't generate report")
      this.loaderGenerateDoc = false
      this.loader = false
    }
  }

  checkReport() {
    this.loader = true
    this.loaderCheckFile = true
    if (this.currentCC && this.currentAgency) {
      console.log("Current CC: ", this.currentCC)
      this.checkDocumentExist(this.currentCC)
      // if (this.currentCC.reportURL){
      //   const signedURLValid:boolean = this.extractDateFromUrl(this.currentCC.reportURL)
      //   if(signedURLValid){
      //     this.checkDocumentExist(this.currentCC,true)
      //   }
      //   else{
      //     this.checkDocumentExist(this.currentCC,false)
      //   }
      // }
      // else {
      //   this.checkDocumentExist(this.currentCC,false)
      //   // alert("No PDF file to check, Generate a report first")
      // }
    }
    else {
      //console.log("can't check report")
      alert("No PDF file to check, Invalid Charter and Agency")
      this.loaderCheckFile = false
      this.loader = false
    }
  }

  private async checkDocumentExist(ccDoc: any) {
    // console.log("checkDocumentExist")
    // const apiUrl = "https://us-central1-arta-respond.cloudfunctions.net/checkDocExist"; //cloudfunc /to check document existence /no checking
    const apiUrl = "https://us-central1-arta-respond.cloudfunctions.net/generateArtemisReportV2/api/v1/checkDocumentExist";
    let serviceData = {
      generationFor: "ccAgencyReports",
      id: this.cc_id,
      agency: { agencyCode: this.currentAgency.id }
    };
    //console.log('serviceData: ',serviceData)
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };
    this.http.post<any>(apiUrl, serviceData, httpOptions)
      .subscribe({
        next: (apiResponse: any) => {
          // { message: string, exist: boolean  }
          //console.log('apiResponse: ',apiResponse)
          if (apiResponse) {
            if (apiResponse.exist == true && ccDoc.reportURL) {
              window.open(ccDoc.reportURL)
              this.loaderCheckFile = false
              this.loader = false
            } else {
              this.generatePDFFile(ccDoc)
              this.loaderCheckFile = false
              this.loader = false
            }
          } else {
            alert("Checking Report failed")
            this.loaderCheckFile = false
            this.loader = false
          }


          // if(apiResponse.exist && urlValid){
          //   window.open(ccDoc.reportURL)
          //   this.loader = false
          // }
          // else if(apiResponse.exist && !urlValid){
          //   this.signUrl(ccDoc)
          // }
          // else if(!apiResponse.exist){
          //   // this.generatePDFFile(ccDoc)
          //   alert("No PDF file to check, Generate a report first")
          //   this.loader = false
          // }
          // else{
          //   alert("Checking Report failed")
          //   this.loader = false
          // }
        },
        error: (err: any) => {
          console.error("Error checking document: ", err)
          this.loader = false
        }
      })
  }


private computeFullProcessingTimeView(clientSteps: any[], situationalSteps: any[], maxHoursPerDay: number = 8) {
  const computeTimeFromSteps = (steps: any[]) => {
    let workingMinutes = 0, calendarMinutes = 0;

    steps?.forEach(step => {
      const actions = step.agency_actions || [];
      actions.forEach((a: any) => {
        const days = parseFloat(a.processing_time_days || '0');
        const hours = parseFloat(a.processing_time_hours || '0');
        const minutes = parseFloat(a.processing_time_minutes || '0');

        const isCalendar = a.total_processing_time?.toLowerCase()?.includes('calendar');

        const totalMins = days * 24 * 60 + hours * 60 + minutes;

        if (isCalendar) {
          calendarMinutes += totalMins;
        } else {
          workingMinutes += (days * maxHoursPerDay * 60) + hours * 60 + minutes;
        }
      });
    });

    const toFormattedString = (totalMins: number, type: 'calendar' | 'working') => {
      const hoursPerDay = type === 'calendar' ? 24 : maxHoursPerDay;
      const days = Math.floor(totalMins / (hoursPerDay * 60));
      const hrs = Math.floor((totalMins % (hoursPerDay * 60)) / 60);
      const mins = totalMins % 60;
      let output = `${days} ${type} day/s`;
      if (hrs > 0) output += `, ${hrs} hour/s`;
      if (mins > 0) output += `, ${mins} minute/s`;
      return output;
    };

    return {
      workingMinutes,
      calendarMinutes,
      workingStr: toFormattedString(workingMinutes, 'working'),
      calendarStr: toFormattedString(calendarMinutes, 'calendar')
    };
  };

  const baseTime = computeTimeFromSteps(clientSteps || []);
  const situationalResults = (situationalSteps || []).map((sit: any) => {
    const res = computeTimeFromSteps(sit.clientStep || sit.requirementSteps || []);
    return {
      situation: sit.situation || 'Unknown',
      title: sit.title || '',
      workingStr: res.workingStr,
      calendarStr: res.calendarStr
    };
  });

  return {
    base: baseTime,
    situational: situationalResults
  };
}







  private async generatePDFFile(ccDoc: any) {
  const apiUrl = "https://us-central1-arta-respond.cloudfunctions.net/generateArtemisReportV2/api/v1/generateDoc";

  let external: any[] = [];
  let internal: any[] = [];

this.services.forEach((service: any) => {
  switch (service.serviceDetails?.service_category) {
    case 'External Service': external.push(service); break;
    case 'Internal Service': internal.push(service); break;
  }
});

  // STEP 1: Compute times per service
  const computeTimes = (service: any) => {
    const maxHrs = service.serviceDetails?.hour_per_day || 8;
    const result = this.computeFullProcessingTimeView(service.clientSteps || [], service.situationalSteps || [], maxHrs);
    service.precomputedProcessingTime = {
      hasSituational: result.situational.length > 0,
      base: result.base,
      situational: result.situational
    };
  };
// Helpers
  function parseTimeStr(str: string, type: 'calendar' | 'working') {
    const regex = new RegExp(`(\\d+)\\s+${type} day/s(?:,\\s*(\\d+)\\s+hour/s)?(?:,\\s*(\\d+)\\s+minute/s)?`, 'i');
   const match = str?.match(regex);
return {
  days: parseInt(match?.[1] || '0'),
  hours: parseInt(match?.[2] || '0'),
  minutes: parseInt(match?.[3] || '0')
};

  }

  function normalizeTime(days: number, hours: number, minutes: number, maxHoursPerDay: number) {
    hours += Math.floor(minutes / 60);
    minutes = minutes % 60;
    days += Math.floor(hours / maxHoursPerDay);
    hours = hours % maxHoursPerDay;
    return { days, hours, minutes };
  }

  function formatTimeString(tp: {days: number, hours: number, minutes: number}, dayLabel: string) {
    let parts = [];
    if (tp.days) parts.push(`${tp.days} ${dayLabel} day/s`);
    if (tp.hours) parts.push(`${tp.hours} hour/s`);
    if (tp.minutes) parts.push(`${tp.minutes} minute/s`);
    return parts.length ? parts.join(', ') : `0 ${dayLabel} day/s`;
  }

  // STEP 2: Format for handlebars (calendarDays, workingDays, etc.)
 const formatProcessedTotalTime = (service: any) => {
    const ppt = service.precomputedProcessingTime;
    const maxHoursPerDay = service.serviceDetails?.hour_per_day || 8;

    const baseCalendar = parseTimeStr(ppt.base.calendarStr, 'calendar');
    const baseWorking = parseTimeStr(ppt.base.workingStr, 'working');

    if (ppt.hasSituational && ppt.situational.length > 0) {
      service.processedTotalTime = {
        hasSituational: true,
        situationalTime: ppt.situational.map((s: any) => {
          const cal = parseTimeStr(s.calendarStr, 'calendar');
          const work = parseTimeStr(s.workingStr, 'working');
          return {
            situation: s.situation,
            title: s.title,
            calendar: normalizeTime(cal.days, cal.hours, cal.minutes, 24),
            working: normalizeTime(work.days, work.hours, work.minutes, maxHoursPerDay),
            valueCalendar: formatTimeString(normalizeTime(cal.days, cal.hours, cal.minutes, 24), 'calendar'),
            valueWorking: formatTimeString(normalizeTime(work.days, work.hours, work.minutes, maxHoursPerDay), 'working')
          };
        })
      };

      // compute totals (base + situational)
      service.processedTotalTime.totals = service.processedTotalTime.situationalTime.map((item: any) => {
        const sumCal = normalizeTime(
          baseCalendar.days + item.calendar.days,
          baseCalendar.hours + item.calendar.hours,
          baseCalendar.minutes + item.calendar.minutes,
          24
        );
        const sumWork = normalizeTime(
          baseWorking.days + item.working.days,
          baseWorking.hours + item.working.hours,
          baseWorking.minutes + item.working.minutes,
          maxHoursPerDay
        );
        return {
          situation: item.situation,
          title: item.title,
          calendarDays: sumCal.days,
          calendarHours: sumCal.hours,
          calendarMinutes: sumCal.minutes,
          workingDays: sumWork.days,
          workingHours: sumWork.hours,
          workingMinutes: sumWork.minutes,
          valueCalendar: formatTimeString(sumCal, 'calendar'),
          valueWorking: formatTimeString(sumWork, 'working')
        };
      });

    } else {
      // No situational times
      const normCal = normalizeTime(baseCalendar.days, baseCalendar.hours, baseCalendar.minutes, 24);
      const normWork = normalizeTime(baseWorking.days, baseWorking.hours, baseWorking.minutes, maxHoursPerDay);
      service.processedTotalTime = {
        hasSituational: false,
        baseTime: {
          calendarDays: normCal.days,
          calendarHours: normCal.hours,
          calendarMinutes: normCal.minutes,
          workingDays: normWork.days,
          workingHours: normWork.hours,
          workingMinutes: normWork.minutes,
          valueCalendar: formatTimeString(normCal, 'calendar'),
          valueWorking: formatTimeString(normWork, 'working')
        }
      };
    }
  };

  // Apply compute + format
  external.forEach(s => {
    computeTimes(s);
    formatProcessedTotalTime(s);
  });

  internal.forEach(s => {
    computeTimes(s);
    formatProcessedTotalTime(s);
  });


  // STEP 3: Final data for PDF generation
  const ccData: any = {
    generationFor: "ccAgencyReports",
    fullEditionStr: "Citizen's Charter " + this.transform(
      this.currentCC?.edition ?? null,
      this.currentCC?.date_posted
        ? this.currentCC.date_posted.toDate().getFullYear()
        : this.currentCC.dateSubmitted.toDate().getFullYear()
    ),
    id: this.cc_id,
    agency: {
      agencyLogoURL: this.currentAgency?.agencyDetails?.logoURL ?? "",
      agencyName: this.currentCC.fromAgencyName,
      agencyCode: this.currentCC.fromAgencyId,
      agency_info: {
        mission: this.currentCC?.agency_profile?.mission ?? "",
        vision: this.currentCC?.agency_profile?.vision ?? "",
        mandate: this.currentCC?.agency_profile?.mandate ?? "",
        pledges: this.currentCC?.agency_profile?.service_pledge ?? ""
      }
    },
    cartDetails: {
      titles: {
        headOfAgencyTitle: this.currentAgency?.cartDetails?.titles?.headOfAgencyTitle ?? 'Agency Head',
        chairPersonTitle: this.currentAgency?.cartDetails?.titles?.chairPersonTitle ?? 'Chairpersons',
        viceChairPersonTitle: this.currentAgency?.cartDetails?.titles?.viceChairPersonTitle ?? 'Vice-Chairpersons',
        membersTitle: this.currentAgency?.cartDetails?.titles?.membersTitle ?? 'Members'
      }
    },
    services: {
      external: external,
      internal: internal
    },
    hOA: this.headOfAgency,
    cP: this.chairPerson,
    vCP: this.viceChairPerson,
    memb: this.member
  };

  const httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  console.log('✅ Final ccData sent to PDF:', JSON.stringify(ccData, null, 2));

  this.http.post<any>(apiUrl, ccData, httpOptions)
    .subscribe(
      (apiResponse: any) => {
        console.log("📥 PDF API Response:", apiResponse);
        if (apiResponse && apiResponse.processDone && apiResponse.result) {
          this.toGetDownloadURL(ccDoc);
        } else {
          alert("Generating PDF failed, try again");
          this.loaderGenerateDoc = false;
          this.loader = false;
        }
      },
      (error: any) => {
        console.error("❌ Error generating PDF:", error);
        this.loaderGenerateDoc = false;
        this.loader = false;
      }
    );
}


  private async toGetDownloadURL(ccDoc: any) {
    // console.log('toGetDownloadURL')
    // const publicBucket = 'artemis_services_public_documents'//functions.config().storagebucket.publicreportsurl;
    // const publicStorage = this.store.storage.app.storage(publicBucket)

    const privateBucket = 'artemis_services_documents'//functions.config().storagebucket.publicreportsurl;
    const privateStorage = this.store.storage.app.storage(privateBucket)

    const storagePath = "reports/agency/" + this.currentCC.fromAgencyId + "/citizenscharter/" + this.cc_id + "/"
    const fileName = this.cc_id + "_agency_cc.pdf"
    const filePath = storagePath + fileName
    privateStorage.ref(filePath).getDownloadURL()
      .then((url) => {
        //console.log('URL: ',url)
        if (url) {
          this.updateFirebaseReportLink(ccDoc, url);
          window.open(url)
          // this.loaderGenerateDoc = false
          // this.loader = false
        } else {
          alert('Failed to generate URL, try again')
          this.loaderGenerateDoc = false
          this.loader = false
        }
      })
      .catch((err) => {
        console.error('Error: ', err)
        alert('Failed to generate URL, try again')
        this.loaderGenerateDoc = false
        this.loader = false
      })
  }

  //added logo url in CC model
  updateFirebaseReportLink(ccDoc: any, link: any) {
    ccDoc.reportURL = link

    this.afs.collection('citizens-charter-phase-02').doc(ccDoc.id).update({
      reportURL: ccDoc.reportURL,
      logoURL: this.currentAgency.agencyDetails.logoURL
    })
      .then(() => {
        this.currentCC.reportURL = link
        this.aCCViewComponent.updateLinkTrigger(link)
        this.currentCCReportURL = link
        this.loaderGenerateDoc = false
        this.loader = false
      })
      .catch(err => {
        this.loaderGenerateDoc = false
        this.loader = false
        console.error("Error updating CC firebase ")
      })
  }
  //

  changeReceiver($event: any) {
    // console.log('updating receiver: ',$event)
    switch ($event.code) {
      case 'loader': this.loader = $event.value; break;
      case 'ccId': {
        if (!this.cc_id) {
          this.cc_id = $event.value
        }
        break;
      }
      case 'currentCC': {
        if (!this.currentCC)
          this.currentCC = $event.value;
        break;
      }
      case 'currentAgency': this.currentAgency = $event.value; break;
      case 'services': this.services = $event.value; break;
      case 'cart': {
        this.headOfAgency = $event.value.headOfAgency,
          this.chairPerson = $event.value.chairPerson,
          this.viceChairPerson = $event.value.viceChairPerson,
          this.member = $event.value.member
        break;
      }
    }
  }

  goToCC() {
    this.router.navigate(['/artemis/citizen-charter/view'], {
      queryParams: {
        cc_id: this.cc_id
      }
    })
  }

  returnToAgencyProfile() {
    this._location.back();
  }
}
